var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.876 5.212c.497.482.035 1.184-.657 1.184H3.167a1 1 0 0 1-1-1v-.651a2.58 2.58 0 0 1 2.578-2.578h1.353c.951 0 1.249.309 1.628.816l.816 1.085c.181.24.204.269.543.269h1.627a3.1 3.1 0 0 1 2.164.875M12.825 7.27a1 1 0 0 1 1 .997l.008 2.446c0 1.72-1.4 3.12-3.12 3.12H5.286c-1.72 0-3.12-1.4-3.12-3.12V8.27a1 1 0 0 1 1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.c5b4098eb5e9c2b54a7c556eefe735f9.svg";
export { ForwardRef as ReactComponent };